import { useQuery } from "@tanstack/react-query"
import axios from "axios"
import useAxiosPrivate from "./useAxiosPrivate"
import PropTypes from "prop-types"
import { getCookie } from "api/apiUtils"
import APP_STATE, { ACCESS_TOKEN_KEY, REFRESH_TOKEN_KEY } from "constants/appState"

// context
import useAppState from "context/hooks/useAppState"

const axiosPublic = axios.create({})

const useGetApi = (apiEndpoint, queryKey, queryOptions = {}, axiosParams = {}, isPublic) => {
  const axiosPrivate = useAxiosPrivate()
  const accessToken = getCookie(ACCESS_TOKEN_KEY)
  const refreshToken = getCookie(REFRESH_TOKEN_KEY)
  const { appStateRef, isMounted } = useAppState()

  const getApi = async () => {
    if (isPublic) {
      let res = await axiosPublic.get(apiEndpoint)
      if (res?.data) return res.data
      return res
    }

    const res = await axiosPrivate
      .get(apiEndpoint, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Cache-Control": "no-store, no-cache, must-revalidate, max-age=0",
          "origin-url": apiEndpoint
        },
        credentials: "include",
        params: axiosParams,
      })
      .catch((error) => {
        return error.response
      })

    if (res?.data) return res.data
  }

  const isEnabled = () => {
    const isQueryValid = queryKey.every((key) => key !== null &&
      key !== undefined &&
      key !== 0 &&
      !Number.isNaN(key))

    const bool =
      (appStateRef?.current === APP_STATE.authenticated || queryOptions?.appState === APP_STATE.authenticated) &&
        (isMounted || queryOptions?.isMounted) &&
        accessToken &&
        refreshToken &&
        isQueryValid &&
        apiEndpoint &&
        queryOptions?.enabled !== false
        ? true
        : false

    return bool
  }

  // all useQuery return values
  const returnedValues = useQuery({
    queryKey,
    queryFn: getApi,
    ...queryOptions,
    enabled: isEnabled(),
    onError: (error) => {
      if (!isEnabled) return null
      return error
    },
  })

  return returnedValues
}

useGetApi.propTypes = {
  apiEndpoint: PropTypes.string.isRequired,
  queryKey: PropTypes.string.isRequired,
  options: PropTypes.object,
}

export default useGetApi
